import { useState } from "react";
import { errorMessage, saveFileHelper } from "../../../utils";
import { exportFtiPdfApi } from "../apis";

// Shared by the create flow (export right after issuing) and the details page
export const useFtiPdfExport = () => {
  const [isExporting, setIsExporting] = useState(false);

  const exportFtiPdf = async ({ id, fti_invoice_number }) => {
    setIsExporting(true);
    try {
      const response = await exportFtiPdfApi(id);
      saveFileHelper({
        response,
        fileName: `FTI-${fti_invoice_number ?? id}.pdf`,
      });
    } catch (error) {
      errorMessage("Failed to export the full tax invoice PDF");
    } finally {
      setIsExporting(false);
    }
  };

  return { isExporting, exportFtiPdf };
};
